import React, { Component } from "react";
import { Dropdown, Icon } from "semantic-ui-react";
import Select, { components } from "react-select";
import CustomDropdown from "../Charts/ChartsOptionsSidebar/CustomDropdown";

const IndicatorsContainer = ({ children, ...props }) => {
    return (
        <components.IndicatorsContainer {...props}>
            <div className="react-select-control">
                {children}
                {/* <p>hello</p> */}
                <Icon
                    name={"caret down"}
                    style={{
                        marginTop: 3,
                    }}
                />
            </div>
        </components.IndicatorsContainer>
    );
};

// const customStyles = {
//     valueContainer: (provided) => ({
//         ...provided,
//         maxWidth: "90%",
//         display: "initial",
//         fontSize: 12,
//     }),
//     control: (base) => ({
//         ...base,
//         border: "1px solid #d3d8de",
//         minHeight: 30,
//         backgroundColor: "#eff1f5",
//         // This line disable the blue border
//         boxShadow: "none",
//     }),
// };

const customStyles = {
    control: (base) => ({ ...base, border: 0, boxShadow: "none", background: "#F5F6FA", height: "36px", minHeight: "36px" }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return { ...styles, backgroundColor: isFocused ? "#F5F6FA" : null, color: "#1f2e3d", opacity: isDisabled ? 0.5 : 1 };
    },
    dropdownIndicator: (provided, state) => ({
        ...provided,
        transform: state.selectProps.menuIsOpen && "rotate(180deg) translateY(5px)",
    }),

    menuList: (base) => ({
        ...base,
        //width: "60%",
        padding: "7px",
        margin: "4px",
        fontSize: 14,

        "::-webkit-scrollbar": {
            width: "2px",
        },
        "::-webkit-scrollbar-track": {
            background: "white",
        },
        "::-webkit-scrollbar-thumb": {
            background: "white",
        },
        "::-webkit-scrollbar-thumb:hover": {
            background: "white",
        },
    }),
};

class VolumeSelector extends Component {
    state = {};

    render() {
        const aggsIntervalOptions = [
            { key: "Volume", label: "Volume", value: "volume" },
            { key: "Impact", label: "Impact", value: "impact" },
            { key: "Traction", label: "Traction", value: "traction" },
        ];

        let obj =
            this.props.appliedFilter && this.props.appliedFilter.clustering_sort_by
                ? aggsIntervalOptions.find((o) => o.value === this.props.appliedFilter.clustering_sort_by).value
                : "volume";

        return (
            <CustomDropdown className="interval-selector" name="Sort By" onChange={this.props.handleSortByChange} value={obj} options={aggsIntervalOptions} />
        );
    }
}

export default VolumeSelector;
